import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Button } from "../../Theme/Hyper";
import Input from "../UI/Form/Input";
const Main = styled.div`
  display: flex;
  flex-direction: column;
`;
const Stats = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 1px solid #f2f2f2;

  margin-top: 1em;
  padding-top: 1em;
  max-height: 500px;
`;
const Entry = styled.div`
  display: flex;
  align-items: center;
`;
const List = styled.div`
  display: flex;
  height: au100%to;
  overflow-y: auto;
`;
const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  > tbody > tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
  }
  th:nth-child(1) {
    width: 65px;
  }
  th:nth-child(2) {
    width: 65px;
  }
  th:nth-child(6) {
    width: 100px;
  }
  th {
    padding: 10px;
    border-top: 1px solid #dee2e6;
  }
  td {
    padding-left: 10px;
    padding-right: 10px;
    border-top: 1px solid #dee2e6;
    width: ${(props) => props.width};
    padding: 4px;
    padding-left: 10px;
    padding-right: 10px;
    border-top: 1px solid #dee2e6;
    white-space: nowrap;
    overflow: hidden;
    font-size: 0.8em;
  }
  > tbody > tr:hover {
    background-color: #14ec8e;
    color: white;
    cursor: pointer;
    > td > div {
      color: #ea1047;
    }
  }
`;

const TH = styled.th`
  border-top: 0;
  border-bottom: 0;
  font-weight: 800;
  font-size: 0.8em;
  text-transform: uppercase;
  color: #343a40;
  text-align: left;
`;

const Row = styled.div`
  display: flex;
`;
export default function Stories({ player, onUpdate }) {
  const [update, setUpdate] = useState(false);
  const [newStory, setNewStory] = useState("");
  const [newBadge, setNewBadge] = useState("");
  const [newTitle, setNewTitle] = useState("");

  if (!player.stories) {
    player.stories = [];
  }

  return (
    <Main>
      <Stats>
        <Entry>
          <Input
            value={newTitle}
            title="Title"
            onChange={(e) => {
              setNewTitle(e.target.value);
            }}
          />
          <Input
            title={
              "Pundit Story " + ((newStory && newStory.length) || 0) + "/60"
            }
            warning={
              newStory?.length > 60
                ? "You are over the limit, please check it looks ok on the graphic"
                : ""
            }
            placeholder=""
            value={newStory}
            onChange={(e) => {
              //if (e.target.value.length <= 55) {
              setNewStory(e.target.value);
              // }
            }}
            onKeyDown={(e) => {
              if (e.keyCode === 13 && e.target.value !== "") {
                if (!player.stories) {
                  player.stories = [];
                }
                player.stories.push({
                  number:
                    player.stories.filter((s) => s.type === "stat").length + 1,
                  story: newStory,
                  badge: newBadge,
                  title: newTitle,
                  type: "stat",
                });
                setNewStory("");
                setUpdate(!update);
                onUpdate(player);
              }
            }}
          />

          <Input
            value={newBadge}
            title="Badge"
            onChange={(e) => {
              setNewBadge(e.target.value);
            }}
          />

          {newStory !== "" && (
            <Button
              style={{ marginTop: "18px" }}
              onClick={() => {
                if (!player.stories) {
                  player.stories = [];
                }
                player.stories.push({
                  number:
                    player.stories.filter((s) => s.type === "stat").length + 1,
                  story: newStory,
                  badge: newBadge,
                  title: newTitle,
                  type: "stat",
                });
                setNewStory("");
                setUpdate(!update);
                onUpdate(player);
              }}
            >
              Add Story
            </Button>
          )}
        </Entry>
        <List>
          <Table>
            <thead>
              <tr>
                <TH>#</TH>
                <TH>Visible</TH>
                <TH>Title</TH>
                <TH>Story</TH>
                <TH>Badge</TH>
                <TH></TH>
              </tr>
            </thead>
            <tbody>
              {player.stories &&
                player.stories
                  .filter((s) => s.type === "stat")
                  .map((story, index) => {
                    return (
                      <tr>
                        <td>{index + 1}</td>
                        <td>
                          <input
                            type="checkbox"
                            checked={story?.visible}
                            onChange={(e) => {
                              story.visible = e.currentTarget.checked;
                              setUpdate(!update);
                              onUpdate(player);
                            }}
                          />
                        </td>
                        <td>
                          <Input
                            title={"title"}
                            value={story.title || ""}
                            onChange={(e) => {
                              // if (e.target.value.length <= 55) {
                              story.title = e.target.value;
                              setUpdate(!update);
                              onUpdate(player);
                              //}
                            }}
                          />
                        </td>
                        <td>
                          <Input
                            title={((story && story.story.length) || 0) + "/60"}
                            warning={
                              story?.story?.length > 60
                                ? "You are over the limit, please check it looks ok on the graphic"
                                : ""
                            }
                            value={story.story}
                            onChange={(e) => {
                              // if (e.target.value.length <= 55) {
                              story.story = e.target.value;
                              setUpdate(!update);
                              onUpdate(player);
                              //}
                            }}
                          />
                        </td>
                        <td>
                          <Input
                            title={"badge"}
                            value={story.badge || ""}
                            onChange={(e) => {
                              // if (e.target.value.length <= 55) {
                              story.badge = e.target.value;
                              setUpdate(!update);
                              onUpdate(player);
                              //}
                            }}
                          />
                        </td>
                        <td>
                          <Button
                            onClick={() => {
                              player.stories = player.stories.filter(
                                (s) => s !== story
                              );
                              setUpdate(!update);
                              onUpdate(player);
                            }}
                          >
                            Delete
                          </Button>
                        </td>
                      </tr>
                    );
                  })}
            </tbody>
          </Table>
        </List>
      </Stats>
    </Main>
  );
}
